import { Text } from '@mantine/core';
import { IconVariable, IconBookmark } from '@tabler/icons-react';
import type { AIMessage } from '~/common/vm/protocol';
import { CollapsibleCard } from '../CollapsibleCard';
import { match } from 'ts-pattern';

export function AIDefineVariableCard({ message }: { message: Extract<AIMessage, { type: 'define-variable' }> }) {
  const categoryLabel = match(message.variableType)
    .with('STATIC', () => 'Static')
    .with('DYNAMIC', () => 'Dynamic')
    .exhaustive();

  return (
    <CollapsibleCard
      icon={IconBookmark}
      title="Define Variable"
      badge={categoryLabel}
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div className="space-y-3">
        {/* Variable name with icon */}
        <div className="mx-1 flex items-center space-x-2 rounded bg-gray-100 px-3 dark:bg-gray-700">
          <IconVariable
            size={14}
            className="text-gray-600 dark:text-gray-400"
          />
          <Text
            size="sm"
            className="font-medium text-blue-800 dark:text-blue-200"
          >
            {message.variableName}
          </Text>
        </div>

        {/* Extracted value (only show if successful) */}
        <div className="mx-1 rounded border border-gray-200 bg-gray-50 p-3 dark:border-gray-600 dark:bg-gray-700">
          <Text
            size="sm"
            className="leading-relaxed"
          >
            &quot;{message.variableValue}&quot;
          </Text>
        </div>
      </div>
    </CollapsibleCard>
  );
}
